var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2007_1268",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2007_1268)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3175 23.1654L18.8275 23.4744L18.1072 23.8741C17.4205 24.2216 16.7166 24.5133 15.9763 24.7288L14.8332 25.007C13.3996 25.28 11.9323 25.2884 10.4925 25.0396C9.95051 24.9459 9.42395 24.8144 8.90113 24.6525C7.16066 24.1138 5.4732 23.1084 4.13942 21.8688C3.03087 20.8385 2.11632 19.6264 1.43425 18.2728C1.10587 17.6211 0.84017 16.9404 0.626598 16.2438C0.511784 15.8694 0.426443 15.5096 0.346601 15.1289C0.0666046 13.7922 0.0138156 12.4415 0.1724 11.0835C0.286554 10.1061 0.504086 9.15039 0.836211 8.22396C1.17559 7.27751 1.61681 6.37065 2.16317 5.52758C2.5483 4.93328 2.96467 4.36559 3.44702 3.85332L3.71998 3.56321L4.13964 3.15124L4.72801 2.6326C5.79301 1.7473 6.9902 1.04192 8.28703 0.545709C9.09799 0.235359 9.94479 0.0154087 10.8044 -0.113922C11.7875 -0.261949 12.7712 -0.281964 13.7559 -0.178368C14.2468 -0.126679 14.7164 -0.0518961 15.197 0.0620382C15.6631 0.172453 16.117 0.302004 16.5682 0.464987C17.8162 0.916105 18.9823 1.54978 20.0282 2.36294L20.3872 2.64887L20.9142 3.11649L21.2665 3.46049L21.7515 3.98375L22.1098 4.40628C22.4373 4.82814 22.7441 5.25529 23.0272 5.70882L23.3765 6.31677L23.9196 7.42444C24.4705 8.69641 24.8024 10.0436 24.9285 11.4249C25.0004 12.2139 25.0017 12.9964 24.9212 13.7821L24.7457 15.0125C24.5741 15.8923 24.3218 16.7426 23.9745 17.5694L23.4735 18.6254C23.1939 19.1295 22.8963 19.6143 22.5534 20.0786C22.1485 20.6267 21.7121 21.1386 21.226 21.6152C20.8935 21.9412 20.555 22.2436 20.1921 22.5328L19.3175 23.1661V23.1654Z",
    fill: "#F07C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4097 3.47712C20.4667 3.48922 20.5089 3.52529 20.5362 3.58534C20.5392 3.58666 20.543 3.59568 20.5454 3.5981C20.5988 3.61701 20.6629 3.64538 20.6563 3.71049L20.9831 4.0402C21.0088 4.0215 21.031 4.04349 21.05 4.10574L21.1591 4.22627C21.1643 4.22143 21.1694 4.21814 21.1729 4.21924C21.2011 4.22803 21.2965 4.34483 21.2954 4.37716L21.3223 4.40795C21.7938 4.94683 22.2164 5.53278 22.5887 6.15106C23.3544 7.42259 23.8765 8.81862 24.1484 10.2784C24.267 10.9154 24.3226 11.5541 24.3457 12.1997C24.3886 13.4004 24.2269 14.7263 23.8957 15.8817C23.7494 16.3913 23.5818 16.8915 23.3726 17.3786C22.8302 18.6412 22.08 19.7933 21.154 20.805L20.479 21.4798L20.3351 21.6131C19.9766 21.9171 19.6229 22.2184 19.2316 22.4848C18.7733 22.7969 18.3037 23.0773 17.8068 23.3248C17.0968 23.6782 16.3613 23.9604 15.5987 24.1716L14.5693 24.401C13.2468 24.6425 12.0714 24.6517 10.7433 24.4358C10.1659 24.3418 9.60506 24.2193 9.04991 24.0414C8.45362 23.8502 7.88396 23.6182 7.32528 23.3404C6.33726 22.849 5.37124 22.1667 4.56446 21.4198L3.97808 20.8338L3.77154 20.6141L3.00326 19.6749C2.9685 19.7009 2.95487 19.656 2.97114 19.6248C2.67597 19.2157 2.40191 18.7984 2.16151 18.3519C1.91362 17.8916 1.69389 17.4328 1.50759 16.9442C1.34043 16.5057 1.19702 16.068 1.07891 15.6129C0.745687 14.3284 0.625154 13.0113 0.721712 11.6861C0.877217 9.55413 1.54015 7.56644 2.70236 5.78066C3.05868 5.23299 3.45086 4.71786 3.89384 4.24431L4.09333 4.03118L4.39444 3.73073C4.67488 3.45095 4.97159 3.20394 5.28194 2.9554C5.92068 2.44402 6.67995 1.95771 7.41766 1.59501C8.5647 1.03083 9.79929 0.647461 11.0724 0.480739C12.0745 0.349429 13.0902 0.357127 14.0912 0.486018C14.5874 0.550023 15.059 0.657799 15.5395 0.788669C17.368 1.2862 19.0143 2.20845 20.4097 3.47646V3.47712Z",
    fill: "#F3B71E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4651 4.32728C21.4756 4.36907 21.4312 4.37347 21.3956 4.36379C21.407 4.41218 21.3567 4.43132 21.321 4.40713C21.2911 4.4322 21.2722 4.40779 21.2942 4.37633C21.2869 4.3363 21.2194 4.23402 21.1578 4.22545C21.1184 4.24656 21.0276 4.1434 21.0487 4.10491C21.0331 4.05828 21.0109 4.03629 20.9819 4.03937C20.9722 4.04487 20.9579 4.05279 20.9513 4.04729C20.8818 3.98922 20.6994 3.81194 20.6497 3.74309L20.655 3.70966C20.6368 3.68283 20.6363 3.66325 20.6491 3.63422C20.6119 3.63224 20.5767 3.61992 20.5442 3.59727C20.5237 3.61354 20.5178 3.60519 20.5349 3.58451C20.5105 3.56713 20.4966 3.54206 20.4933 3.50907L20.4084 3.4763L20.3396 3.43868C18.8332 2.09963 17.0689 1.17979 15.1127 0.70712C13.0749 0.214431 10.8696 0.347281 8.88327 1.01835C7.07484 1.62937 5.37242 2.72231 4.11145 4.05015C2.12045 6.14671 0.938003 8.82351 0.742027 11.7671C0.557488 14.5396 1.34183 17.305 2.94615 19.5604L2.96968 19.6244C2.96771 19.7603 2.90282 19.748 2.77503 19.587C2.75413 19.5971 2.73368 19.5659 2.74907 19.5487C2.7262 19.4966 2.69387 19.45 2.6567 19.4073L2.6369 19.4141C2.48557 19.1911 2.34195 18.9599 2.2025 18.7292C2.20096 18.7266 2.2036 18.7211 2.20756 18.7151C2.17258 18.5957 2.10176 18.4653 2.02214 18.3718C1.99464 18.3716 1.95703 18.2983 1.97089 18.2739C1.92162 18.1305 1.8398 17.9796 1.75578 17.8527C1.72586 17.8452 1.69067 17.766 1.69683 17.7348C1.659 17.6061 1.61083 17.4757 1.53517 17.3635C1.52439 17.3651 1.52483 17.362 1.53451 17.3552C1.53341 17.3037 1.52329 17.2606 1.48062 17.2283C1.46896 17.223 1.46962 17.2179 1.48172 17.2131C1.45071 17.0919 1.40518 16.9775 1.34513 16.87C1.33303 16.866 1.3227 16.8612 1.31874 16.8532C1.23515 16.6784 1.16565 16.4408 1.11198 16.2521C1.10956 16.2435 1.11352 16.233 1.11924 16.2222L1.08273 16.0225C1.04116 15.8789 0.99277 15.7381 0.937343 15.6004C0.929645 15.6002 0.923485 15.5995 0.922825 15.5973C0.904349 15.5285 0.807572 15.1607 0.813731 15.1216C0.814391 15.1169 0.82165 15.1132 0.830888 15.1099C0.849143 15.0741 0.833086 15.0265 0.804712 14.9999C0.796134 14.9991 0.789095 14.9975 0.787996 14.994C0.777438 14.9617 0.749284 14.8326 0.754783 14.8057C0.755443 14.802 0.763801 14.8 0.774139 14.7985C0.753023 14.6498 0.725091 14.5031 0.690559 14.3588C0.683521 14.357 0.677802 14.355 0.676702 14.3515C0.659326 14.2897 0.615557 13.9506 0.622375 13.9074C0.623035 13.9026 0.630291 13.8989 0.639089 13.8951C0.639749 13.852 0.631172 13.8111 0.613136 13.7731C0.607197 13.7724 0.602359 13.7715 0.602139 13.7698C0.565847 13.5386 0.554408 13.2355 0.54869 12.999C0.537472 12.5402 0.539234 12.0735 0.586523 11.6173C0.603239 11.5716 0.611597 11.5216 0.611157 11.4675C0.594001 11.4504 0.590482 11.4233 0.60038 11.3864C0.609178 11.2291 0.630953 11.0575 0.652068 10.9012C0.652508 10.8983 0.658665 10.8961 0.666803 10.8941C0.683299 10.8616 0.691878 10.8246 0.692318 10.7833L0.674503 10.7677C0.702657 10.5633 0.733668 10.3607 0.777218 10.161C0.777878 10.1579 0.785358 10.1562 0.794815 10.1551C0.834406 10.0928 0.851341 10.028 0.845843 9.96087C0.870697 9.88169 0.884334 9.80163 0.886973 9.72091C0.882354 9.70133 0.879496 9.68197 0.882575 9.66372C0.979134 9.11868 1.21844 8.44058 1.42629 7.92171C1.47138 7.8091 1.52021 7.68878 1.57234 7.57925C1.57366 7.57639 1.58114 7.57639 1.59037 7.57727C1.62271 7.54978 1.63788 7.5104 1.64668 7.47015C1.61171 7.4486 1.65812 7.34434 1.69793 7.35996C1.73136 7.31927 1.74324 7.2678 1.75138 7.21765C1.74412 7.21325 1.7384 7.20951 1.73906 7.20841C1.8299 6.98802 1.97067 6.72034 2.09032 6.51205C2.30675 6.13549 2.5355 5.74508 2.7957 5.38458L2.84167 5.35313C2.88346 5.334 2.9037 5.29792 2.9169 5.25547C2.9114 5.25173 2.90656 5.24778 2.90392 5.24272C2.89952 5.23436 3.00378 5.09007 3.01323 5.08941C3.02027 5.08897 3.02731 5.09139 3.03457 5.09469C3.07834 5.07973 3.10297 5.043 3.10825 4.98427C3.10671 4.9691 3.10693 4.95524 3.11353 4.94556C3.25848 4.73067 3.4461 4.5149 3.61722 4.3264C3.6192 4.3242 3.62624 4.3264 3.63437 4.32992C3.67243 4.31673 3.69684 4.29319 3.72147 4.26218C3.70982 4.25668 3.69882 4.24722 3.70256 4.23842C3.7118 4.21643 3.90469 4.00704 3.94363 3.96502C4.17611 3.71384 4.43587 3.46992 4.69805 3.24909C4.70685 3.24161 4.71697 3.24491 4.72577 3.25349C4.76404 3.23545 4.79483 3.2051 4.81133 3.16595C4.80913 3.14417 4.82342 3.12437 4.854 3.10612C5.01412 2.95809 5.21274 2.80765 5.3898 2.67326C5.42081 2.64972 5.79517 2.36775 5.82772 2.36357C5.83234 2.36291 5.83762 2.36884 5.84312 2.37676C5.91196 2.34663 5.97773 2.30594 6.04063 2.25491C6.01666 2.23512 6.02963 2.2228 6.05185 2.20894C6.39959 1.96348 6.76955 1.75034 7.1615 1.56955C7.18305 1.55129 7.20263 1.54843 7.22023 1.56097C7.25036 1.55833 7.26465 1.54711 7.26333 1.52731C7.55763 1.34212 7.87106 1.19145 8.20362 1.0751C8.23706 1.07708 8.27269 1.09225 8.31008 1.12019C8.33031 1.08324 8.35781 1.0586 8.39256 1.04628C8.44139 1.0509 8.46646 1.02891 8.468 0.979859C8.75218 0.863945 9.04295 0.766947 9.34032 0.688424C9.43292 0.658951 9.52706 0.635636 9.62296 0.6187C9.90582 0.533579 10.192 0.465615 10.4812 0.415246L10.501 0.39809L11.1853 0.293393C11.6208 0.248524 12.0413 0.213112 12.4812 0.212892C13.0458 0.212672 13.5961 0.246104 14.1557 0.326166C15.7132 0.548536 17.3412 1.13734 18.677 1.96854C19.3674 2.3981 20.0165 2.87869 20.6053 3.43604L21.1981 4.03145L21.3846 4.23996L21.4636 4.32772L21.4651 4.32728Z",
    fill: "#F9D43D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4656 4.32845C21.8531 4.75977 22.1985 5.23553 22.5183 5.73129C23.5171 7.27974 24.1668 9.03605 24.4057 10.8663C24.6764 12.9413 24.4543 14.9927 23.7223 16.9518C23.2824 18.1288 22.6503 19.2294 21.8738 20.215C21.53 20.6514 21.1673 21.061 20.7655 21.4412L19.7517 22.312C19.2525 22.7009 18.7235 23.0326 18.1646 23.3315C17.4981 23.688 16.8055 23.9779 16.0918 24.2038C16.0608 24.2102 16.0451 24.2056 16.0449 24.19L16.0537 24.1574C16.2499 24.0274 16.4963 23.937 16.7261 23.8939C16.9175 23.8721 17.1024 23.7921 17.2643 23.6865C17.7885 23.4661 18.299 23.2171 18.776 22.9059C18.8211 22.8557 18.8803 22.8188 18.9535 22.7953C18.9898 22.7497 19.0321 22.7222 19.0798 22.7132C19.1537 22.662 19.2278 22.6103 19.3022 22.5582C19.3272 22.53 19.3596 22.5076 19.3994 22.4908C19.4251 22.4656 19.446 22.4359 19.4623 22.402C19.5072 22.389 19.5283 22.3774 19.532 22.3276C19.5905 22.2958 19.6363 22.2586 19.6677 22.199C19.724 22.1385 19.785 22.0872 19.8505 22.0452C19.9209 22.0743 20.0504 21.9757 20.1098 21.9302C20.1817 21.875 20.3095 21.7604 20.3533 21.6847C20.3555 21.6286 20.3854 21.5774 20.443 21.5312L20.478 21.4808L20.4677 21.4527C21.8252 20.193 22.9857 18.4882 23.631 16.6307C25.0616 12.513 24.2447 7.88043 21.4009 4.54268C21.3686 4.50177 21.3442 4.45558 21.3215 4.40873C21.3367 4.39004 21.3558 4.3896 21.3759 4.39202C21.3701 4.35132 21.3246 4.34429 21.3393 4.30272C21.3448 4.28688 21.382 4.26444 21.3913 4.29304C21.3965 4.30953 21.3913 4.33857 21.4139 4.34275C21.4258 4.34495 21.446 4.33813 21.4654 4.32867L21.4656 4.32845Z",
    fill: "#FCD33D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4795 21.4798C20.4615 21.5724 20.3713 21.5975 20.379 21.6934C20.2972 21.7924 20.2204 21.894 20.1124 21.9611L19.9279 22.0757C19.9006 22.0926 19.8549 22.0735 19.8272 22.0654L19.6875 22.2184C19.6563 22.275 19.6153 22.3187 19.554 22.3405C19.5571 22.3911 19.5245 22.4149 19.4803 22.4201C19.4552 22.4841 19.4165 22.5295 19.3459 22.5444C19.329 22.5941 19.2663 22.5998 19.2381 22.6273C19.1774 22.6867 19.1268 22.7435 19.0338 22.7496C18.9973 22.809 18.9432 22.8418 18.8798 22.8574C18.8339 22.8633 18.8213 22.9102 18.7908 22.9295L18.6058 23.047L18.0332 23.3714L17.5403 23.5938L17.3373 23.6897C17.3046 23.7051 17.2815 23.7035 17.252 23.7255C17.1493 23.8025 17.0254 23.8395 16.9082 23.8857C16.8466 23.9099 16.7951 23.9059 16.7333 23.9202L16.4956 23.9758C16.4542 23.9855 16.4375 23.9943 16.4069 24.0088L16.295 24.0618C16.1848 24.114 16.1278 24.1606 16.0462 24.1896L16.0317 24.2088C15.2361 24.4415 14.4357 24.6106 13.6153 24.6982C13.3078 24.6982 13.0014 24.7054 12.6957 24.7202C12.4397 24.7325 12.1837 24.7228 11.9281 24.6909C11.9048 24.6797 11.8768 24.6823 11.8443 24.6988C11.6494 24.7034 11.4424 24.6876 11.2456 24.6682C11.036 24.6476 10.7626 24.6157 10.5604 24.5653C10.4432 24.5361 10.355 24.5011 10.249 24.4505C10.0161 24.4505 9.80006 24.4186 9.5733 24.3667L9.4895 24.3429C9.44837 24.3313 9.42219 24.3256 9.38766 24.3172C9.35797 24.2976 9.32299 24.2847 9.28208 24.2781L9.27812 24.264C9.27548 24.2838 9.24975 24.2734 9.25085 24.2541C9.21236 24.2185 9.16595 24.1943 9.11404 24.1857C9.09733 24.2204 9.05729 24.1943 9.07203 24.1595C9.00142 24.0429 8.87122 23.9972 8.74936 24.0665L8.72979 24.0588L8.71945 24.0797C8.60178 24.0546 8.48674 24.0185 8.37435 23.9719C8.33542 23.9679 8.29363 23.9488 8.25689 23.9358C8.23358 23.9154 8.20608 23.9 8.17419 23.8898V23.8729C8.11041 23.812 8.042 23.7577 7.9692 23.7104C7.8788 23.6969 7.78752 23.6859 7.69558 23.6774C7.69206 23.6813 7.68854 23.6849 7.68436 23.6857C7.65247 23.6928 7.17012 23.433 7.09929 23.395C6.51577 23.0804 5.91706 22.7463 5.41931 22.3066C5.32781 22.2532 5.23962 22.1958 5.15516 22.1342V22.1188C5.14922 22.1228 5.14416 22.1256 5.1424 22.1241C5.05618 22.0572 4.97084 21.9816 4.89297 21.9079C4.83051 21.8309 4.7632 21.759 4.69106 21.6921C4.66312 21.6868 4.63959 21.6653 4.61979 21.6272C4.56283 21.5733 4.50498 21.5203 4.44625 21.4682C4.39281 21.4381 4.34376 21.4015 4.29889 21.3584C4.27403 21.3186 4.23994 21.2861 4.19859 21.2641C4.19243 21.2674 4.18737 21.2696 4.18561 21.268C4.13172 21.2185 4.06442 21.1515 4.01625 21.0969C4.01427 21.0945 4.01669 21.0881 4.02065 21.0804C3.954 21.0111 3.9087 20.9361 3.8845 20.8554C3.72548 20.7127 3.57129 20.566 3.42195 20.4151C3.39137 20.4269 3.32429 20.3552 3.34342 20.3273C3.31791 20.2908 3.28932 20.2567 3.25764 20.2246C3.2506 20.2292 3.24489 20.2327 3.24313 20.2312C3.21519 20.2074 3.14899 20.1274 3.13645 20.0948C3.13557 20.0926 3.14151 20.0878 3.14921 20.0823L3.00932 19.8599C2.93608 19.7981 2.88197 19.7007 3.00316 19.6749L3.03021 19.665C3.93201 20.8429 4.95456 21.8639 6.29208 22.7212C8.49708 24.1344 11.1972 24.7824 13.8014 24.4896C16.2167 24.1967 18.6326 23.1719 20.4463 21.473L20.4787 21.4803L20.4795 21.4798Z",
    fill: "#FBD43B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22269 1.56164C7.18552 1.60519 7.10282 1.61619 7.04959 1.63796C6.86 1.71626 6.69569 1.81458 6.52655 1.92104L6.19003 2.13307C6.15132 2.15748 6.13724 2.20653 6.08093 2.21577C6.06641 2.21819 6.04508 2.24195 6.04288 2.25514C5.98019 2.30683 5.91443 2.34752 5.84536 2.37699C5.78466 2.40119 5.70504 2.47355 5.63971 2.51512C5.47893 2.61762 5.34102 2.72584 5.19783 2.84373C5.12151 2.90663 5.04233 2.957 4.9748 3.03113L4.91498 3.07754C4.87583 3.10789 4.84481 3.13428 4.8138 3.16596C4.79818 3.20489 4.76629 3.23634 4.72824 3.2535L4.55954 3.39251L4.41833 3.5126L3.96193 3.96768C3.92762 4.00199 3.91244 4.04818 3.88165 4.07985L3.74704 4.2182C3.73252 4.23294 3.72306 4.24393 3.72394 4.26219C3.70459 4.29254 3.67203 4.3207 3.63684 4.32993L3.47804 4.50941C3.34343 4.66162 3.21696 4.81514 3.11072 4.98429C3.10083 5.03026 3.08873 5.08546 3.03704 5.0947C3.00933 5.11428 3.00449 5.15761 2.98029 5.18554L2.91958 5.25548C2.90837 5.29618 2.88505 5.33731 2.84436 5.35314C2.65169 5.60323 2.47902 5.87003 2.3233 6.1542C2.27425 6.24372 2.21288 6.31631 2.17505 6.41396L2.10291 6.518L1.78596 7.14156L1.75385 7.2181C1.74593 7.26825 1.73383 7.32016 1.7004 7.36041C1.66521 7.38262 1.64695 7.43101 1.64915 7.4706C1.64057 7.51042 1.62518 7.55111 1.59285 7.57772L1.43976 7.92656L1.27392 8.37878C1.24576 8.45554 1.22575 8.52879 1.19891 8.60533L1.1459 8.75665C1.03483 9.07404 0.948831 9.39539 0.889224 9.72114C0.886805 9.8023 0.872948 9.8828 0.847874 9.96286C0.854032 10.0295 0.837095 10.0935 0.797064 10.1553L0.719423 10.5673C0.705347 10.6425 0.692149 10.7116 0.694569 10.7835C0.694569 10.8253 0.68577 10.8622 0.669054 10.8944L0.650799 11.0567L0.627263 11.3057C0.621764 11.3639 0.612966 11.4132 0.613626 11.4675C0.613186 11.5195 0.605048 11.5694 0.588992 11.6173C0.588332 11.7073 0.586131 11.7944 0.577113 11.8901L0.562819 12.0418V13.0617L0.577334 13.2278L0.590092 13.4458L0.615825 13.7728C0.633641 13.8105 0.64222 13.8511 0.64178 13.8949C0.638041 13.9607 0.655417 14.022 0.660696 14.0922L0.670152 14.222C0.673671 14.2702 0.697647 14.3152 0.693248 14.3586C0.72822 14.5033 0.756155 14.6498 0.77683 14.7983C0.765173 14.8649 0.793986 14.9324 0.807183 14.9997C0.836657 15.0248 0.850952 15.0745 0.833356 15.1097C0.823678 15.1482 0.843475 15.1928 0.853372 15.2353L0.939591 15.6002C0.994579 15.7381 1.04319 15.8791 1.0852 16.0236L1.12149 16.222C1.19341 16.4384 1.244 16.6661 1.34716 16.8697C1.40699 16.9764 1.45274 17.0908 1.48375 17.2129L1.48265 17.228C1.52488 17.2544 1.53786 17.3077 1.53654 17.355C1.53852 17.3565 1.5405 17.3602 1.5372 17.3633C1.61286 17.4748 1.66191 17.6059 1.69886 17.7346L1.75781 17.8525C1.84139 17.9798 1.92431 18.1305 1.97292 18.2737L2.02417 18.3716C2.10049 18.4679 2.17483 18.5946 2.20959 18.7149L2.58768 19.3156C2.61034 19.3517 2.62045 19.3908 2.6585 19.4073C2.69634 19.4491 2.72823 19.4968 2.75088 19.5487L2.77684 19.587C2.81753 19.6339 2.86042 19.6752 2.90551 19.7108C2.98777 19.8325 3.06915 19.9561 3.14943 20.0819C3.16505 20.1336 3.21586 20.1919 3.25787 20.2242C3.29064 20.2559 3.31924 20.2902 3.34365 20.3269C3.34849 20.3617 3.39578 20.3922 3.42217 20.4147C3.5779 20.5649 3.73296 20.7178 3.88715 20.8728C3.91882 20.9481 3.96325 21.0171 4.02088 21.08L4.1986 21.2637C4.23973 21.2855 4.27448 21.3185 4.2989 21.3581L4.38402 21.4249C4.39457 21.4416 4.3816 21.452 4.36246 21.4594L3.94148 21.0431C2.67412 19.7269 1.73449 18.1743 1.15646 16.4373C0.832038 15.4623 0.645739 14.4848 0.567217 13.4684L0.552259 13.2753L0.539062 13.001V12.1571L0.54984 11.8898L0.562599 11.6983L0.579095 11.4823C0.626164 10.8653 0.7302 10.2572 0.872508 9.65053C1.24356 8.06953 1.92409 6.58289 2.86438 5.259C3.46308 4.41593 4.16846 3.65249 4.96556 2.99506C5.67226 2.41219 6.43263 1.90234 7.24337 1.49279C7.32101 1.48488 7.28758 1.55702 7.22247 1.56076L7.22269 1.56164Z",
    fill: "#FAD041"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0452 24.1895L16.092 24.2033C15.6119 24.3553 15.1276 24.4754 14.6239 24.5651C14.0854 24.661 13.5564 24.749 13.0169 24.7444C12.9564 24.7472 12.8964 24.7508 12.8372 24.7549L12.3194 24.7545C12.2695 24.7512 12.2187 24.7481 12.1668 24.7457C11.5067 24.7565 10.2249 24.5524 9.57227 24.3665C9.63033 24.3555 9.6928 24.3703 9.75284 24.39C9.82301 24.4131 9.88129 24.412 9.95036 24.4131L10.1653 24.4162C10.2128 24.4169 10.2724 24.4206 10.3095 24.4435C10.4481 24.5286 10.5994 24.5664 10.7558 24.5891L10.9102 24.6115L11.117 24.6377C11.2432 24.6538 11.358 24.6738 11.4878 24.6634C11.6534 24.65 11.7601 24.7123 11.9009 24.6522C11.9422 24.6725 11.9996 24.6762 12.0456 24.6784L12.3212 24.6907L12.5095 24.7094C12.5807 24.7165 12.6351 24.6931 12.7041 24.6927L12.8676 24.6916C12.9032 24.6914 12.9641 24.6738 12.9982 24.6771C13.0448 24.6817 13.0673 24.6775 13.1128 24.6771L13.3691 24.6744C13.4555 24.6568 13.5303 24.661 13.6152 24.6806C13.6455 24.6775 13.697 24.6522 13.7379 24.6601C13.8052 24.6731 13.8664 24.6522 13.9266 24.6439L14.1483 24.6126L14.3386 24.5856L14.495 24.5625L14.7635 24.504L14.9067 24.4659L15.0545 24.4393L15.1647 24.4129L15.4337 24.3527L15.6735 24.2974C15.7971 24.2691 15.9348 24.2295 16.0456 24.1899L16.0452 24.1895Z",
    fill: "#FCD43F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5058 0.398438L10.521 0.43231C10.4618 0.421532 10.4187 0.436049 10.3646 0.449686L10.2692 0.47388C10.1295 0.509292 9.90493 0.522929 9.78021 0.591994C9.72017 0.625206 9.6401 0.647201 9.56862 0.655559C9.53497 0.659519 9.49516 0.632025 9.46305 0.668536C9.43291 0.702849 9.38672 0.689432 9.34801 0.700649L8.92307 0.824701L8.66089 0.91994C8.61008 0.938416 8.54915 0.970308 8.49834 0.983945L8.48141 1.04553C8.47085 1.0838 8.38661 1.04553 8.3534 1.11438C8.34526 1.13109 8.32942 1.14715 8.31622 1.14825C8.26497 1.15243 8.24474 1.07632 8.19019 1.09678C7.89172 1.20785 7.66209 1.30925 7.38583 1.47179C7.33503 1.50171 7.29477 1.57055 7.22461 1.56131C7.23319 1.5512 7.26486 1.5468 7.2653 1.52898C7.2653 1.51864 7.25122 1.50237 7.24551 1.49335C7.76415 1.23139 8.29467 1.00682 8.85158 0.822722L9.70389 0.568899L10.5056 0.398438H10.5058Z",
    fill: "#FAD140"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69608 23.678C7.71169 23.6778 7.72731 23.678 7.74271 23.68C7.80627 23.6883 8.08891 23.8038 8.13994 23.8425C8.15225 23.8518 8.16347 23.8625 8.17447 23.8737L8.22528 23.8995C8.24661 23.9103 8.25739 23.9208 8.25717 23.9367C7.9345 23.8232 7.63097 23.6769 7.31776 23.5247C6.89568 23.3197 6.50175 23.0936 6.10848 22.8373C5.77107 22.6176 5.44049 22.4001 5.14245 22.1401C5.1154 22.1152 5.1198 22.1106 5.15565 22.1192L5.25771 22.1854C5.37428 22.2285 5.45588 22.296 5.5454 22.379L5.65186 22.4777L5.77679 22.5809L6.05283 22.77L6.1958 22.8585L6.46149 23.0142C6.57125 23.0786 6.68299 23.1209 6.7868 23.1965L6.89084 23.2541L7.10881 23.38L7.402 23.5363L7.6963 23.6782L7.69608 23.678Z",
    fill: "#FAD140"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69078 21.6921C4.76292 21.7576 4.83023 21.8295 4.89269 21.9078L5.15465 22.1185L5.14146 22.1394L4.36239 21.4596C4.36701 21.438 4.35139 21.4202 4.33534 21.4028L4.29883 21.3584L4.38835 21.4046C4.46005 21.4415 4.52801 21.4809 4.56651 21.5531C4.62523 21.5834 4.67032 21.6347 4.69078 21.6921Z",
    fill: "#FBD241"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07343 24.16L9.11545 24.1861C9.16713 24.1936 9.21486 24.2185 9.25225 24.2546L9.27953 24.2644C9.30284 24.2761 9.30658 24.2858 9.27953 24.2911L8.87262 24.1558L8.7556 24.1001L8.75692 24.0819C8.73493 24.057 8.83963 24.0337 8.86096 24.0333C8.94608 24.0309 9.0312 24.0867 9.07321 24.1602L9.07343 24.16Z",
    fill: "#FCD440"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7287 24.0583C8.75466 24.0553 8.77182 24.057 8.75466 24.0808L8.87035 24.1547L8.41924 24.0031C8.3979 23.9957 8.38119 23.9913 8.37305 23.9717C8.51382 23.9858 8.65194 24.0832 8.72848 24.0583H8.7287Z",
    fill: "#FAD140"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38666 24.3169L9.27734 24.2903V24.2637C9.34773 24.2894 9.39282 24.2859 9.38666 24.3169Z",
    fill: "#FCD43F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0178 24.7447C13.0123 24.7502 13.0029 24.7557 12.9894 24.7557L12.8379 24.7553C12.8386 24.7504 12.8425 24.7432 12.8526 24.7432L13.0176 24.7445L13.0178 24.7447Z",
    fill: "#FBD43B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3206 24.7542C12.2698 24.7542 12.2157 24.7643 12.168 24.7454L12.3063 24.7432C12.316 24.7432 12.32 24.7493 12.3204 24.7542H12.3206Z",
    fill: "#FBD43B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97178 19.6248L3.00389 19.675C2.98146 19.7016 2.95814 19.7227 2.95616 19.7432C2.95308 19.7753 2.97134 19.8081 2.99642 19.8206C3.03843 19.8413 3.03887 19.8791 3.05888 19.9099C3.09715 19.9686 3.13103 20.0201 3.14972 20.0826C3.11057 20.0645 3.09583 20.0234 3.0734 19.9906L2.9962 19.8782L2.8805 19.7232L2.77734 19.5879C2.81891 19.607 2.84685 19.6438 2.87874 19.6811C2.89238 19.697 2.94231 19.7007 2.94473 19.684C2.94913 19.6541 2.95397 19.635 2.97178 19.6253V19.6248Z",
    fill: "#FAD140"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97292 18.2747L1.75781 17.8535C1.79234 17.8632 1.80532 17.8966 1.82138 17.9283L1.92256 18.1278C1.94631 18.1746 1.9991 18.2211 1.97292 18.2747Z",
    fill: "#FAD140"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69877 17.7346L1.53711 17.3633C1.60221 17.4178 1.63059 17.4928 1.65544 17.5744C1.67194 17.6288 1.71329 17.6774 1.69877 17.7346Z",
    fill: "#FAD140"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.797095 10.1549C0.804573 10.1151 0.810513 10.0801 0.847465 10.0429C0.844385 10.0181 0.828548 9.9831 0.835586 9.95605L0.863961 9.84717C0.877598 9.79483 0.881338 9.76469 0.889256 9.7207C0.910591 9.75721 0.905752 9.81132 0.883977 9.85289C0.838887 9.93867 0.891454 10.0443 0.796875 10.1549H0.797095Z",
    fill: "#FAD140"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12331 16.2226L1.08349 16.0444L1.03906 15.8867C1.01707 15.8087 0.967581 15.7482 0.961202 15.6635L0.941406 15.6006C0.985396 15.6191 0.969559 15.6697 0.986935 15.7108L1.06106 15.8885C1.06634 15.9415 1.08657 15.9723 1.09559 16.0211L1.12331 16.2224V16.2226Z",
    fill: "#FAD140"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2965 4.37714L21.1602 4.22625C21.1672 4.20909 21.1833 4.20733 21.1947 4.20997C21.2061 4.21261 21.2134 4.21877 21.2222 4.23065L21.3097 4.34788C21.319 4.3602 21.3084 4.37626 21.2965 4.37714Z",
    fill: "#FCD33D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6577 3.71103L20.5469 3.59863L20.6879 3.61051L20.6577 3.71103Z",
    fill: "#FCD33D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5366 3.58577C20.4808 3.56378 20.4546 3.51803 20.4102 3.47756C20.4462 3.47294 20.5085 3.46436 20.5243 3.50769C20.5331 3.53166 20.5182 3.56664 20.5366 3.58577Z",
    fill: "#FCD33D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21081 18.7154L2.15384 18.6019L2.02539 18.3721C2.05508 18.3824 2.07774 18.4026 2.09842 18.4284C2.10347 18.5447 2.21961 18.5707 2.21081 18.7154Z",
    fill: "#FAD140"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04322 2.25586C6.0386 2.28423 5.99065 2.29457 5.97636 2.31151C5.94072 2.35792 5.90905 2.37903 5.8457 2.37793C5.93082 2.34406 5.9647 2.26642 6.04322 2.25608V2.25586Z",
    fill: "#FAD140"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48425 17.2132C1.46643 17.2022 1.46841 17.1807 1.45939 17.1567L1.4121 17.0309C1.38923 16.97 1.37427 16.9229 1.34766 16.8701C1.42662 16.9024 1.40946 17.0254 1.45961 17.103C1.48337 17.1396 1.48733 17.1734 1.48425 17.2132Z",
    fill: "#FAD140"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.777553 14.7981C0.750499 14.7706 0.753136 14.7275 0.748297 14.6907L0.719265 14.4701C0.714206 14.4312 0.690011 14.3964 0.69375 14.3584C0.719045 14.3707 0.722783 14.3971 0.726523 14.4255L0.760176 14.6784C0.766114 14.7226 0.784371 14.7574 0.777332 14.7981H0.777553Z",
    fill: "#FAD140"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0493 4.10502L20.9824 4.03948C20.9899 4.01638 21.0073 4.00033 21.033 4.00605L21.0493 4.10502Z",
    fill: "#FCD33D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75253 19.5496C2.72108 19.503 2.67665 19.4632 2.66016 19.4082C2.7136 19.4313 2.74066 19.494 2.75253 19.5496Z",
    fill: "#FAD140"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53826 17.3554L1.48438 17.2285C1.51363 17.2314 1.5321 17.2501 1.54156 17.2703C1.5519 17.2923 1.54882 17.335 1.53826 17.3556V17.3554Z",
    fill: "#FAD140"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03711 5.09381C3.0778 5.065 3.0866 5.02189 3.11079 4.9834C3.11321 5.01485 3.11101 5.054 3.08462 5.08304C3.07274 5.09601 3.05053 5.09601 3.03711 5.09381Z",
    fill: "#FAD140"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70117 7.36008L1.75462 7.21777C1.75638 7.27276 1.74912 7.32995 1.70117 7.36008Z",
    fill: "#FAD140"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63672 4.32946C3.66113 4.30197 3.68665 4.27272 3.72382 4.26172C3.72558 4.30439 3.67917 4.34112 3.63672 4.32946Z",
    fill: "#FAD140"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8457 5.35352L2.92092 5.25586C2.92554 5.30249 2.89805 5.3577 2.8457 5.35352Z",
    fill: "#FAD140"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0.587891 11.6167C0.588111 11.5799 0.610984 11.5403 0.597787 11.4924C0.594708 11.481 0.606146 11.4656 0.612525 11.4669L0.613626 11.576C0.613846 11.5991 0.601747 11.6129 0.587891 11.6167Z",
    fill: "#FAD140"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5918 7.57782L1.6481 7.4707C1.65052 7.51381 1.63535 7.56396 1.5918 7.57782Z",
    fill: "#FAD140"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0.832813 15.11C0.843591 15.0669 0.814339 15.0385 0.806641 15C0.835234 15.0009 0.843153 15.0264 0.845792 15.0499C0.848432 15.0735 0.851949 15.0966 0.832593 15.11H0.832813Z",
    fill: "#FAD140"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73047 3.25356L4.81603 3.16602C4.81669 3.21045 4.77424 3.25158 4.73047 3.25356Z",
    fill: "#FAD140"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 10.8941C0.672148 10.8573 0.680287 10.818 0.693484 10.7832L0.695903 10.8531C0.696783 10.8773 0.683365 10.8908 0.667969 10.8941Z",
    fill: "#FAD140"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0.64119 13.8945L0.615234 13.7725C0.649327 13.8015 0.643609 13.8523 0.64119 13.8945Z",
    fill: "#FAD140"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1737 23.873C8.01094 23.8177 7.85038 23.7522 7.69531 23.6774C7.75624 23.6468 7.82684 23.6719 7.89635 23.6695C7.98191 23.6666 8.05119 23.7225 8.10816 23.7832C8.13521 23.8123 8.16997 23.8316 8.1737 23.873Z",
    fill: "#FCD43F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02209 21.0804L3.91036 20.9566C3.86527 20.88 3.81512 20.8204 3.75133 20.7595L3.60507 20.6196L3.44054 20.4559C3.42866 20.4441 3.42405 20.4278 3.42383 20.415L3.52896 20.5046C3.56921 20.5387 3.60661 20.5591 3.63784 20.6033L3.74627 20.6942C3.77289 20.7164 3.78564 20.734 3.81182 20.7564L3.91498 20.8442C3.90574 20.9629 3.9825 20.9913 4.02209 21.0804Z",
    fill: "#FAD140"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89332 21.9084C4.83723 21.8633 4.78511 21.8136 4.73848 21.7513C4.72154 21.7287 4.70064 21.7186 4.69141 21.6924C4.73672 21.6924 4.75497 21.7309 4.78093 21.7632C4.82052 21.8125 4.87353 21.8485 4.89332 21.9082V21.9084Z",
    fill: "#FAD140"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07271 24.1597C9.0373 24.1153 8.98957 24.0869 8.94008 24.0574C8.89939 24.0332 8.8818 24.0319 8.83297 24.0541C8.81427 24.0627 8.76676 24.0471 8.75642 24.0816C8.74851 24.0765 8.74323 24.0634 8.73047 24.0592L8.79403 24.0385C8.85342 24.0191 8.88972 24.0152 8.94514 24.0385C9.00057 24.0618 9.05907 24.0972 9.07271 24.1595V24.1597Z",
    fill: "#FCD43F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25009 24.2534C9.20192 24.2358 9.15551 24.2114 9.11328 24.185C9.17047 24.1709 9.22743 24.2026 9.25009 24.2534Z",
    fill: "#FCD43F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29952 21.358L4.19922 21.2637C4.24607 21.2736 4.28676 21.3136 4.29952 21.358Z",
    fill: "#FAD140"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34359 20.3273C3.3117 20.2948 3.27101 20.2688 3.25781 20.2246C3.29674 20.2545 3.33634 20.2765 3.34359 20.3273Z",
    fill: "#FAD140"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8389 21.6264C16.221 22.6113 14.2876 23.1636 12.3899 23.1258C11.6825 23.1117 10.9822 23.0233 10.2953 22.8645C8.54007 22.4589 6.92761 21.6088 5.60725 20.39L5.30811 20.1021L5.212 20.0066L5.00414 19.7891C4.49364 19.2177 4.03284 18.61 3.65013 17.9422L3.20429 17.0864C2.6311 15.8096 2.2838 14.4285 2.23651 13.0221C2.16964 11.0417 2.66013 9.08413 3.60416 7.3518C3.78496 7.0199 3.98357 6.70955 4.19671 6.39942C4.54753 5.88914 4.93596 5.42174 5.3686 4.98184L5.53312 4.81468C5.7445 4.59979 5.96731 4.40997 6.20441 4.21729C7.04286 3.53611 7.98029 2.98513 8.99558 2.60396C11.1476 1.79608 13.4373 1.71998 15.6229 2.44515C16.3316 2.68028 17.0086 2.98513 17.6489 3.3674C18.4328 3.83568 19.1478 4.39853 19.7762 5.0597C20.477 5.79742 21.0768 6.61519 21.5429 7.52117L22.0186 8.549C22.5786 9.94634 22.8571 11.4561 22.8098 12.9693C22.7783 13.9776 22.5995 14.9792 22.2907 15.9387C21.9933 16.8622 21.5715 17.7273 21.0359 18.5325C20.7627 18.9432 20.4572 19.3215 20.1391 19.6943L20.0063 19.8377L19.761 20.0959L19.5299 20.3273L19.317 20.527C18.8678 20.948 18.369 21.3033 17.8389 21.6261V21.6264Z",
    fill: "#FFEEA9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8728 9.05392C21.8455 9.10561 21.7998 9.04226 21.7809 9.00267C21.7512 8.88764 21.7133 8.90018 21.6674 9.04028C21.6309 9.07064 21.6031 9.10451 21.5845 9.14168C21.5796 9.16896 21.6542 9.46017 21.69 9.46325C21.6953 9.46369 21.7584 9.38957 21.7609 9.38473C21.7356 9.29609 21.7402 9.2202 21.8521 9.2257C21.8365 9.17511 21.8055 9.06712 21.8845 9.09043L22.0127 9.47799C22.0074 9.50306 22.0134 9.51516 22.0336 9.53121L22.1233 9.83145C22.1077 9.8607 22.0743 9.86092 22.0233 9.83254C21.9705 9.8541 21.9414 9.84332 21.9362 9.80021C21.8649 9.79471 21.8772 9.91503 21.8878 9.96605C21.8695 10.0463 21.8765 10.1 21.9093 10.1275C22.0052 10.0507 22.2287 10.2711 22.0444 10.2746C22.0835 10.3263 22.0521 10.356 21.9986 10.3703C21.9903 10.4559 21.9962 10.5443 22.0162 10.6356L22.0178 10.7902C22.0672 10.9545 22.1018 11.1223 22.1209 11.2935C22.1477 11.3495 22.1959 11.3887 22.2652 11.4113C22.2764 11.4644 22.2689 11.5222 22.2425 11.5853C22.2672 11.6254 22.2813 11.6656 22.2848 11.7061C22.261 11.7817 22.2302 11.8515 22.192 11.915C22.2049 11.9355 22.2162 11.9601 22.2177 11.9852C22.226 12.1416 22.2254 12.3004 22.2036 12.4557C22.2188 12.5553 22.2199 12.6523 22.2071 12.7462C22.2366 12.8012 22.2287 12.8835 22.1904 12.9297C22.2309 12.9818 22.2258 13.0608 22.2063 13.1226C22.1992 13.2589 22.1992 13.3951 22.2056 13.531C22.1719 13.6342 22.1574 13.7384 22.1623 13.8442C22.0864 14.1299 22.0369 14.4201 22.0136 14.7143C21.9914 14.819 21.959 14.9193 21.9168 15.0155C21.9054 15.1426 21.8794 15.2666 21.8387 15.3878L21.5774 16.1462C21.5636 16.2267 21.5589 16.3079 21.5636 16.3899C21.5576 16.4542 21.5196 16.503 21.4494 16.5364L21.4019 16.5852C21.3258 16.7295 21.2587 16.8769 21.2004 17.0271C21.2281 17.0843 21.2147 17.1402 21.1918 17.1967C21.2112 17.2713 21.1738 17.3153 21.0794 17.3287L21.0201 17.3839C20.9195 17.5389 20.8221 17.6962 20.728 17.8555C20.726 17.9186 20.7066 17.9762 20.6701 18.0277C20.6857 18.1379 20.6468 18.1882 20.5531 18.1786C20.4176 18.3191 20.2982 18.472 20.1952 18.6372C20.1673 18.8004 20.1244 19.0021 19.9265 19.0192C19.8081 19.1015 19.6652 19.2532 19.5783 19.3711C19.5383 19.4255 19.5376 19.4589 19.5449 19.5253C19.5251 19.59 19.4863 19.6478 19.4285 19.6991L19.1967 19.7589C19.068 19.8768 18.942 19.9976 18.8184 20.1214C18.8428 20.1713 18.8296 20.2362 18.7937 20.2771C18.8188 20.3094 18.819 20.3213 18.788 20.3508C18.7781 20.36 18.5599 20.4317 18.5474 20.4293C18.5135 20.4049 18.4917 20.3902 18.4557 20.4185L18.0399 20.7304C18.0092 20.7687 17.9971 20.8158 18.0034 20.8712C17.9949 20.8908 17.8869 20.9594 17.8596 20.9741C17.7841 21.0153 17.7327 21.0432 17.6473 21.017C17.476 21.0775 17.2996 21.1947 17.1487 21.2997C17.1107 21.3722 17.0662 21.4395 17.0154 21.5018L16.9756 21.5172C16.9061 21.5161 16.8375 21.5071 16.77 21.4901L16.3314 21.6943C16.2828 21.7398 16.2498 21.791 16.2322 21.8482C16.2392 21.9166 16.2205 21.9386 16.1761 21.9142C16.1506 21.8509 16.1057 21.8423 16.0419 21.8887C15.9781 21.8706 15.9168 21.8695 15.8576 21.8854L15.0475 22.1687C14.9037 22.179 14.7774 22.2318 14.6516 22.2932C14.6875 22.3644 14.6839 22.4458 14.5832 22.4128C14.4961 22.4355 14.4246 22.4254 14.3846 22.338C14.3177 22.3369 14.2495 22.338 14.18 22.3411C13.5261 22.4656 12.8676 22.5138 12.1998 22.4957C12.1499 22.4775 12.1068 22.4788 12.0709 22.4997C11.9018 22.4678 11.7302 22.4524 11.556 22.4537C11.37 22.3979 11.1491 22.36 10.9567 22.3664C10.7959 22.4801 10.6976 22.4606 10.6619 22.3081C10.5478 22.2591 10.3745 22.214 10.2614 22.2782C10.2205 22.287 10.191 22.2597 10.1728 22.1968C9.88287 22.095 9.58528 21.9973 9.28548 21.9296C9.19552 21.9481 9.11261 21.9428 9.03672 21.9135C8.93973 21.9303 8.89266 21.9028 8.89574 21.8311C8.92345 21.7961 8.93225 21.7824 8.89133 21.7534C8.82843 21.7083 8.54315 21.5761 8.46749 21.5544C8.44747 21.5486 8.42724 21.5473 8.40678 21.5491C8.32848 21.5713 8.24908 21.5658 8.16858 21.5321C8.08104 21.6316 7.91827 21.6577 8.03639 21.4948C7.97282 21.4541 7.98404 21.4143 8.02099 21.359C8.02341 21.352 8.02495 21.341 8.02033 21.3353C8.00691 21.3188 7.69679 21.1358 7.65785 21.1182C7.59231 21.0883 7.54238 21.0692 7.46958 21.0964L7.42295 21.0947C7.38467 21.1428 7.34597 21.1914 7.30659 21.2403L7.27074 21.2484L7.22917 21.224C7.23247 21.1635 7.24149 21.1048 7.256 21.0478C7.18012 20.9812 7.13569 20.8829 7.12029 20.7834L6.751 20.5063C6.67314 20.5087 6.59417 20.51 6.51455 20.5103C6.51081 20.5534 6.50356 20.5842 6.4622 20.6064C6.50048 20.6484 6.50597 20.6781 6.4787 20.6957L6.20706 20.481C6.18023 20.4427 6.16747 20.4056 6.19321 20.362C6.28207 20.3449 6.33925 20.2448 6.3111 20.1586C6.3034 20.1348 5.96511 19.8269 5.9407 19.822C5.83842 19.8658 5.73593 19.9107 5.63299 19.9564L5.60506 19.9419L5.41546 19.7523C5.39082 19.6898 5.46517 19.6764 5.51532 19.689L5.55139 19.6124C5.52456 19.5662 5.52983 19.5104 5.56722 19.4448C5.55667 19.4164 5.24258 19.0654 5.21882 19.0544C5.17681 19.035 5.07476 19.0641 5.07894 19.1294L5.03429 19.1525C5.02483 19.2108 4.97292 19.2451 4.92343 19.2068L4.70524 18.9343C4.7224 18.9068 4.74373 18.8806 4.76881 18.8562C4.89066 18.8732 4.91683 18.84 4.84711 18.757L4.87746 18.6292C4.87482 18.605 4.61352 18.2364 4.58955 18.2397C4.58163 18.2408 4.4523 18.3006 4.44658 18.3061C4.43404 18.3635 4.38367 18.4702 4.32429 18.4181L3.84061 17.6419L3.45372 16.8811C3.2991 16.5347 3.15833 16.1968 3.04329 15.8339C2.59724 14.4277 2.44305 13.0911 2.5924 11.6181C2.7435 10.1271 3.22476 8.64371 3.97457 7.35238C4.17692 7.00376 4.38983 6.67582 4.62496 6.35051C4.90583 5.96186 5.21619 5.61346 5.54611 5.26616C5.8591 4.93645 6.19562 4.64348 6.5548 4.36414C7.14405 3.90554 7.77443 3.52305 8.45121 3.20588C9.02308 2.93798 9.61255 2.73475 10.2256 2.57946C11.2221 2.32696 12.2185 2.2315 13.2455 2.30782C13.8457 2.35247 14.433 2.45079 15.0137 2.60872C16.019 2.88211 16.9712 3.2998 17.8407 3.87431C18.4902 4.30321 19.094 4.79414 19.6258 5.36249C20.076 5.84353 20.4777 6.35821 20.8291 6.9138L21.2673 7.67747L21.6168 8.40727L21.8739 9.05458L21.8728 9.05392Z",
    fill: "#D09114"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3527 22.4275C11.3966 22.402 10.4651 22.2443 9.56682 21.9423C8.0672 21.4382 6.70592 20.5729 5.62223 19.4208C4.38676 18.1071 3.53402 16.5395 3.15262 14.7706C3.01559 14.1345 2.93795 13.5006 2.92871 12.8498C2.91354 11.7773 3.07476 10.7097 3.40601 9.68912C3.66863 8.88015 4.02231 8.11516 4.46594 7.39394C4.63619 7.11724 4.80687 6.86232 5.00373 6.60608C5.21466 6.33158 5.42361 6.06984 5.66226 5.81998L5.93697 5.53228C6.21147 5.24481 6.51808 4.99692 6.83371 4.75146C8.05422 3.80281 9.48719 3.16694 11.0106 2.9019L11.8686 2.80072C12.5309 2.74815 13.1861 2.77301 13.8486 2.86275C15.5009 3.08643 17.1877 3.84724 18.4697 4.90806C18.8747 5.24305 19.2492 5.59915 19.597 5.9933C20.254 6.73827 20.7885 7.5754 21.202 8.4805C22.0437 10.323 22.3459 12.384 21.9925 14.3853C21.7481 15.769 21.2198 17.0768 20.4211 18.2305C20.1524 18.6187 19.8664 18.9877 19.5451 19.3322L18.9912 19.8851C18.6668 20.1867 18.331 20.461 17.9652 20.7157C17.0225 21.372 15.9674 21.8585 14.8507 22.141C14.0349 22.3475 13.2017 22.4504 12.3525 22.4275H12.3527Z",
    fill: "url(#paint0_linear_2007_1268)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98631 19.7023C5.00005 18.7856 4.22627 17.6621 3.71994 16.4257C3.21647 15.1962 2.96133 13.8336 3.00972 12.5091C3.02952 11.9642 3.08736 11.4315 3.19778 10.8988L3.41157 10.0302L3.62734 9.39258C3.94671 8.55127 4.37781 7.77221 4.91581 7.04835C5.28489 6.5517 5.69268 6.0953 6.15567 5.68466C7.14193 4.81013 8.28303 4.14391 9.52971 3.71544C10.2978 3.4515 11.094 3.26916 11.9028 3.19482C13.8372 3.01688 15.7684 3.41125 17.4594 4.37639C17.7649 4.55081 18.0534 4.72018 18.3279 4.93771L18.9143 5.40268C19.2405 5.68378 19.5381 5.97917 19.8174 6.30712C20.1357 6.68103 20.4214 7.06309 20.6748 7.48275C21.2869 8.49628 21.7037 9.58636 21.9092 10.7541C22.3409 13.21 21.748 15.7826 20.3801 17.8607C19.9912 18.4515 19.5408 18.9921 19.0379 19.4868C18.485 20.0305 17.8674 20.4829 17.2007 20.8753C15.837 21.6777 14.3088 22.1125 12.7342 22.1757L12.0365 22.1748C9.8152 22.1075 7.62626 21.227 5.98631 19.7025V19.7023Z",
    fill: "url(#paint1_linear_2007_1268)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1241 9.83112C22.2734 10.3759 22.3797 10.9366 22.4452 11.5085C22.7127 13.8465 22.1467 16.2642 20.8572 18.2301C19.9461 19.6189 18.7566 20.7462 17.2995 21.5494C14.635 23.0182 11.5416 23.1907 8.73327 22.0135C8.21991 21.7984 7.7314 21.5479 7.27148 21.2479C7.29876 21.1944 7.34011 21.15 7.38828 21.1051L7.40829 21.0622C7.41335 21.0514 7.45184 21.0737 7.46614 21.069C7.53762 21.0448 7.60603 21.0545 7.67223 21.0939L8.00634 21.2925C8.02569 21.3039 8.04263 21.3116 8.04835 21.3295C8.0633 21.3757 8.01404 21.4073 8.01646 21.4333C8.01844 21.4553 8.07452 21.4764 8.07254 21.5012C8.07144 21.5151 7.98742 21.5707 8.02547 21.5842C8.07628 21.6018 8.10818 21.5362 8.13545 21.5169C8.19088 21.4775 8.26302 21.543 8.30657 21.5415C8.38267 21.523 8.4359 21.5063 8.50958 21.5406L8.86304 21.7051C8.90154 21.723 8.95608 21.7566 8.94662 21.8041C8.94376 21.818 8.91231 21.834 8.92089 21.8569C8.94509 21.9218 9.02361 21.8593 9.0753 21.9007C9.12369 21.9392 9.25807 21.8798 9.36497 21.9123L9.79277 22.0425L10.0677 22.1257C10.1095 22.1384 10.146 22.1686 10.1935 22.1717L10.2336 22.2621L10.3138 22.2194C10.3528 22.2238 10.377 22.2262 10.4133 22.2207C10.4678 22.2123 10.5232 22.2431 10.578 22.2489C10.7449 22.266 10.6884 22.3733 10.7445 22.4088C10.7654 22.422 10.7898 22.4198 10.8151 22.4068L10.9238 22.3507C11.0045 22.3091 11.1079 22.3406 11.1972 22.3575C11.2983 22.3766 11.4103 22.3667 11.5042 22.4079C11.5511 22.4283 11.5755 22.4332 11.628 22.425C11.7464 22.4063 11.8399 22.4618 11.9624 22.4512C11.9907 22.4488 12.0437 22.489 12.0649 22.4728C12.1168 22.433 12.1559 22.4686 12.201 22.4684L13.0188 22.4637L13.2983 22.4389L13.4387 22.4167L13.8073 22.3795L14.0741 22.3309C14.1597 22.3153 14.2327 22.3014 14.3205 22.3144C14.3376 22.317 14.3717 22.2992 14.3977 22.3137C14.4148 22.3232 14.4225 22.3542 14.4421 22.3733C14.4801 22.4105 14.5353 22.3914 14.5844 22.3859C14.5971 22.3843 14.624 22.4072 14.64 22.3892C14.6671 22.3586 14.6152 22.3186 14.6266 22.2821C14.6299 22.2717 14.6466 22.2583 14.6629 22.255C14.7469 22.2379 14.7876 22.182 14.9266 22.1604L15.041 22.1426L15.2172 22.0835L15.8324 21.8655C15.8876 21.8459 15.9443 21.8353 15.9985 21.8573C16.0424 21.8752 16.0697 21.8479 16.1071 21.8301C16.1344 21.8171 16.1757 21.8635 16.1916 21.8831C16.2065 21.8963 16.1966 21.9194 16.2087 21.9137C16.1867 21.7997 16.2457 21.7568 16.3154 21.6735L16.7447 21.4711C16.7876 21.4509 16.8241 21.4636 16.8662 21.4819C16.9082 21.5001 16.995 21.5019 17.019 21.4623L17.1279 21.2831C17.197 21.2087 17.2944 21.1748 17.3793 21.1236L17.5155 21.0413C17.5817 21.0015 17.6446 20.9676 17.7235 21.0086L17.8465 20.9507L17.9809 20.8623C17.9699 20.7945 17.9861 20.7345 18.0407 20.6938L18.4241 20.4077C18.4643 20.3775 18.5054 20.3542 18.5521 20.4052L18.7934 20.3199C18.7802 20.3071 18.7676 20.2922 18.7676 20.275C18.7676 20.2535 18.8257 20.228 18.7934 20.1164C18.8488 20.0238 18.9396 19.968 19.0144 19.8952L19.1851 19.735L19.4125 19.679C19.444 19.6215 19.5313 19.5864 19.517 19.4935C19.5067 19.4258 19.5306 19.3829 19.574 19.3345L19.8051 19.0759C19.8564 19.0187 19.9155 18.9771 20.0002 18.9824L20.0889 18.8964C20.1062 18.8539 20.1373 18.8055 20.1443 18.7637C20.1546 18.7022 20.1472 18.6542 20.1876 18.5972L20.3286 18.3991C20.392 18.3102 20.4529 18.2253 20.5373 18.1562C20.5629 18.1353 20.5879 18.147 20.6187 18.1488C20.6711 18.1514 20.5994 18.0098 20.6891 17.951L20.7032 17.8457L20.9449 17.4451C21.0659 17.2448 21.122 17.3059 21.1589 17.2718C21.1822 17.2503 21.1589 17.2135 21.1655 17.1915C21.1831 17.1328 21.2045 17.1018 21.1763 17.0402C21.1682 17.0222 21.1816 16.9782 21.1917 16.9571L21.3754 16.577C21.3868 16.553 21.4321 16.5134 21.4543 16.498C21.4875 16.4749 21.5181 16.4686 21.5324 16.4197C21.5467 16.3709 21.521 16.226 21.5568 16.121L21.6956 15.7154L21.742 15.5965C21.757 15.558 21.7585 15.5342 21.7717 15.4968L21.8122 15.3816C21.8258 15.2661 21.8863 15.2104 21.8876 15.0303C21.8878 14.9881 21.9145 14.9727 21.9217 14.9467L21.9868 14.7103L21.9969 14.5328L22.073 14.0975L22.1067 13.9818L22.134 13.8476C22.1434 13.8008 22.137 13.7733 22.1313 13.7251L22.1786 13.5298C22.172 13.4605 22.1628 13.4038 22.1762 13.3338L22.1795 13.1181C22.2004 13.0527 22.1997 12.9903 22.1652 12.9298C22.1984 12.8708 22.2098 12.8088 22.1808 12.7479C22.2149 12.6403 22.1533 12.4941 22.1865 12.3594C22.2107 12.2613 22.1859 12.1668 22.1876 12.0707C22.1887 12.0154 22.2022 11.9818 22.1696 11.9303C22.1483 11.8967 22.2112 11.8562 22.2151 11.8302C22.2204 11.7948 22.2296 11.7473 22.2516 11.7163C22.2765 11.6813 22.2323 11.6373 22.2202 11.6083C22.1967 11.552 22.2681 11.4792 22.2448 11.4273C22.2365 11.4088 22.1001 11.42 22.0781 11.228C22.0612 11.0798 22.048 10.9377 21.9914 10.7958L21.9892 10.6377L21.973 10.5156C21.9598 10.4171 21.9424 10.3407 22.0229 10.3344C22.0363 10.3333 22.04 10.3007 22.0271 10.2943L21.9793 10.2708C21.9604 10.2613 21.9666 10.2407 21.973 10.2281C21.9939 10.1861 22.051 10.2809 22.09 10.2429C22.0959 10.2371 22.0966 10.2217 22.0933 10.2202C22.0594 10.2035 22.0596 10.1687 22.0075 10.1542L21.9802 10.1335C21.9646 10.1217 21.9052 10.1859 21.8691 10.1353C21.8254 10.0739 21.8843 9.99674 21.848 9.90414L21.8744 9.77811L21.9756 9.76953C21.9756 9.78097 21.9723 9.78911 21.9694 9.79439C21.9516 9.8056 21.9657 9.82276 21.9785 9.81814C22.0405 9.78097 22.0662 9.83728 22.1234 9.83156L22.1241 9.83112Z",
    fill: "#D49210"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22867 21.2236L6.47776 20.6952C6.47512 20.6539 6.41112 20.6097 6.43839 20.589L6.4771 20.5598C6.48568 20.5415 6.4782 20.485 6.51076 20.4845L6.64009 20.483C6.6832 20.4825 6.72895 20.4564 6.7681 20.4852L7.11936 20.7438C7.17039 20.7815 7.14751 20.8288 7.16555 20.8703C7.17875 20.9009 7.2113 20.9345 7.21988 20.9768L7.28674 21.0392C7.28938 21.0771 7.27288 21.094 7.26365 21.1307C7.25595 21.1618 7.27178 21.2093 7.22845 21.2233L7.22867 21.2236Z",
    fill: "#D49210"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20747 20.4797L5.72556 20.0545L5.60547 19.9406L5.7381 19.8737C5.84368 19.8743 5.9057 19.7455 5.97916 19.8121L6.31635 20.1181C6.35836 20.1561 6.34296 20.2175 6.33262 20.2659C6.31943 20.3279 6.27566 20.3651 6.21143 20.3772C6.20439 20.4128 6.20901 20.4438 6.20769 20.4794L6.20747 20.4797Z",
    fill: "#D49210"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70322 18.9334L4.32227 18.4172C4.43334 18.3844 4.39331 18.2914 4.4373 18.2797C4.56839 18.245 4.57631 18.1651 4.63745 18.2489L4.88996 18.5951C4.92625 18.6448 4.875 18.7042 4.87082 18.752C4.88094 18.7806 4.92977 18.8111 4.90645 18.8503C4.85916 18.9295 4.77734 18.8377 4.75931 18.9022C4.75183 18.9288 4.72851 18.9343 4.70322 18.9334Z",
    fill: "#D49210"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8742 9.05398L21.8856 9.09049C21.8623 9.10303 21.8552 9.12986 21.8634 9.15823L21.8891 9.24951L21.7884 9.26007C21.7697 9.30098 21.7769 9.34497 21.7948 9.396C21.7363 9.43185 21.7096 9.47738 21.7039 9.53369C21.6722 9.4732 21.6265 9.43559 21.6126 9.37796L21.5601 9.15845C21.5506 9.1193 21.5887 9.07861 21.6144 9.0586C21.7059 8.98799 21.6287 8.91057 21.7736 8.8877C21.7912 8.96776 21.8242 9.05222 21.8744 9.05398H21.8742Z",
    fill: "#D49210"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0336 9.53077C22.016 9.53077 21.998 9.53956 21.985 9.55166C21.9672 9.52901 21.9692 9.51317 21.9742 9.50327C21.9806 9.49118 21.9984 9.48392 22.0129 9.47754L22.0338 9.53077H22.0336Z",
    fill: "#D49210"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98481 19.0885C4.97799 19.0711 4.95929 19.0243 4.97007 19.0014C4.98701 18.9658 5.02748 18.9928 5.03166 19.021C5.03518 19.0443 5.02374 19.0777 4.98481 19.0885Z",
    fill: "#D49210"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41608 19.752L5.31468 19.646L4.92383 19.2065C4.94692 19.1981 4.97969 19.1988 4.99905 19.1779L5.01203 19.1319C5.01467 19.1225 5.04326 19.1187 5.0602 19.1148C5.06635 19.0666 5.09165 19.0283 5.1462 19.0277L5.23946 19.0264L5.57312 19.4016C5.65054 19.4885 5.4968 19.5232 5.58434 19.607L5.52913 19.7238C5.4748 19.7029 5.44555 19.704 5.41564 19.7518L5.41608 19.752Z",
    fill: "#D49210"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2239 7.22388C18.5611 7.4027 18.8657 7.62683 19.1239 7.90902C19.2719 8.07069 19.4013 8.23345 19.5132 8.42063C19.6661 8.67621 19.7954 8.93157 19.8902 9.21663C20.1775 10.0806 20.1572 10.8203 19.9846 11.7027C19.9437 11.9119 19.875 12.0978 19.7965 12.2942C19.5968 12.7935 19.292 13.2252 18.9189 13.6101L18.843 13.6884C18.3525 14.1605 17.756 14.5038 17.0958 14.6798C16.8012 14.7471 16.5215 14.8212 16.2182 14.8227L15.0337 14.8291L14.3888 18.7106C14.3321 19.0521 14.0523 19.2794 13.7068 19.2794H12.1816C12.0195 19.2794 11.8728 19.2303 11.7549 19.1294C11.5545 18.9578 11.4947 18.7196 11.5363 18.464L12.3976 13.1621L12.8786 10.235C12.9075 10.0595 12.9904 9.92707 13.1048 9.79246L9.92163 9.79136L9.76899 10.6989H11.908C12.3288 10.7081 12.6156 11.0647 12.5487 11.4581L12.2799 13.0409C12.225 13.388 11.9408 13.6121 11.5913 13.6115L9.18172 13.6062L8.49811 17.6077C8.43389 17.8943 8.2135 18.113 7.92338 18.1554H6.02785C5.63722 18.1064 5.38472 17.7454 5.4496 17.3587L5.66119 16.109L6.37933 11.8257L6.55112 10.8341L6.90568 8.76023L7.11265 7.59119C7.13618 7.45812 7.16082 7.33341 7.2213 7.21728C7.37637 6.90935 7.65746 6.80069 7.98519 6.79277C10.8808 6.78904 13.7721 6.79123 16.6592 6.79959C17.1862 6.83171 17.7255 6.9595 18.1975 7.1988C18.2076 7.20408 18.216 7.2131 18.2234 7.22366L18.2239 7.22388Z",
    fill: "#F6A91F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1047 7.01489C18.4419 7.19371 18.7466 7.41784 19.0048 7.70004C19.1528 7.8617 19.2821 8.02447 19.3941 8.21164C19.547 8.46723 19.6763 8.72259 19.7711 9.00764C20.0583 9.87161 20.0381 10.6113 19.8654 11.4937C19.8245 11.7029 19.7559 11.8888 19.6774 12.0852C19.4777 12.5845 19.1728 13.0162 18.7998 13.4012L18.7239 13.4795C18.2334 13.9515 17.6369 14.2948 16.9766 14.4708C16.6821 14.5381 16.4023 14.6122 16.099 14.6137L14.9146 14.6201L14.2697 18.5016C14.2129 18.8432 13.9332 19.0704 13.5876 19.0704H12.0625C11.9004 19.0704 11.7537 19.0213 11.6358 18.9204C11.4354 18.7488 11.3756 18.5106 11.4171 18.255L12.2785 12.9531L12.7595 10.026C12.7883 9.85049 12.8712 9.71808 12.9856 9.58347L9.80249 9.58237L9.64984 10.4899H11.7889C12.2096 10.4991 12.4964 10.8557 12.4296 11.2492L12.1608 12.8319C12.1058 13.179 11.8216 13.4031 11.4721 13.4025L9.06258 13.3972L8.37897 17.3987C8.31475 17.6853 8.09436 17.904 7.80424 17.9464H5.90871C5.51808 17.8974 5.26558 17.5364 5.33046 17.1498L5.54205 15.9L6.26019 11.6167L6.43197 10.6252L6.78653 8.55125L6.99351 7.38221C7.01704 7.24914 7.04167 7.12443 7.10216 7.00829C7.25722 6.70036 7.53832 6.59171 7.86605 6.58379C10.7617 6.58005 13.6529 6.58225 16.54 6.59061C17.067 6.62272 17.6063 6.75051 18.0783 6.98982C18.0885 6.9951 18.0968 7.00412 18.1043 7.01467L18.1047 7.01489Z",
    fill: "url(#paint2_linear_2007_1268)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1057 7.01577C17.9132 6.91372 17.715 6.84157 17.5047 6.77471C17.1907 6.66935 16.8741 6.62888 16.5409 6.59743L7.73081 6.59875C7.56541 6.59875 7.30257 6.74128 7.21129 6.86401L7.10352 7.00917C7.10462 6.94473 7.19787 6.83739 7.2676 6.77977C7.39627 6.67331 7.54826 6.58929 7.72312 6.58533L7.86278 6.57059H10.0216L10.1498 6.56949C10.1995 6.58819 10.231 6.57081 10.2765 6.57081L11.4873 6.57169L11.5876 6.56993L14.5392 6.57081C14.5959 6.57081 14.6313 6.59303 14.6892 6.57741C14.778 6.55322 14.8774 6.57543 14.9711 6.58247C15.0915 6.55938 15.2063 6.57125 15.327 6.57191L16.2425 6.57697L16.6432 6.58841C17.1385 6.6258 17.6105 6.75865 18.059 6.96892C18.0839 6.98058 18.1002 6.98674 18.1052 7.01533L18.1057 7.01577Z",
    fill: "#DBB460"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0851 12.1645C15.47 12.1924 15.9578 12.1689 16.3056 12.027C17.1365 11.6883 17.5932 10.7478 17.2852 9.91373C17.2087 9.70609 17.0985 9.52331 16.9225 9.38607C16.6747 9.19273 16.3595 9.07418 16.0333 9.07374L9.62547 9.06912C9.52033 9.06912 9.43829 9.16414 9.42311 9.25146L9.17303 10.6937C9.16445 10.7429 9.16489 10.8067 9.19898 10.8391C9.22493 10.8635 9.27288 10.9039 9.32721 10.9039L11.7869 10.9072C11.9193 10.9072 12.0196 11.019 11.9963 11.1571L11.7387 12.6869C11.7172 12.8147 11.5936 12.8837 11.473 12.8839L8.86971 12.8857C8.76766 12.8857 8.69398 12.9902 8.67924 13.0773L8.5686 13.7332L8.3029 15.2794L8.09483 16.4907L7.97782 17.1668C7.95714 17.286 7.87202 17.42 7.72817 17.4202L5.96351 17.4233C5.83814 17.4235 5.74092 17.2755 5.76028 17.1565L5.9248 16.1465L6.42673 13.1452L6.85783 10.5903L7.43124 7.26245C7.46291 7.07791 7.62282 6.95605 7.80933 6.95605L16.2735 6.95649C16.5394 6.95649 16.7914 6.98157 17.0484 7.026C17.3116 7.07153 17.5461 7.15775 17.7889 7.26816C18.8438 7.74788 19.4636 8.779 19.5564 9.92121C19.6189 10.6899 19.461 11.4576 19.1075 12.1412C18.9153 12.5129 18.6676 12.8329 18.3656 13.1206C17.9743 13.4932 17.5124 13.7717 16.9953 13.9324C16.626 14.0473 16.2572 14.1053 15.8703 14.1069L14.7353 14.111C14.6285 14.1115 14.546 14.1907 14.529 14.2923L14.3852 15.1549L14.2086 16.2215L13.986 17.5396L13.8498 18.3504C13.8329 18.4509 13.7095 18.5483 13.6028 18.5481L12.0341 18.5459C11.8734 18.5457 11.8025 18.3561 11.825 18.2221L11.9921 17.2227L12.5708 13.698L12.9084 11.6465L13.1823 10.0116C13.2003 9.90339 13.3035 9.79649 13.4148 9.79627L15.0455 9.79451C15.1924 9.79451 15.2751 9.9322 15.2529 10.062L15.1225 10.819L14.9298 11.9498C14.9126 12.051 14.9643 12.1561 15.0855 12.1649L15.0851 12.1645Z",
    fill: "#FEFEFE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6699 11.3082C16.4372 11.5632 16.1315 11.7022 15.7943 11.7486L15.4023 11.755L15.6674 10.1751C15.7041 9.95555 15.6414 9.74726 15.4947 9.58691H15.9909C16.1682 9.58691 16.3316 9.62563 16.4931 9.69645C16.6376 9.77871 16.77 9.88605 16.8487 10.0361C17.0689 10.4562 16.9926 10.9548 16.6697 11.3085L16.6699 11.3082Z",
    fill: "#F1B61D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.96794 5.71412C5.0333 5.71412 5.08628 4.97122 5.08628 4.05481C5.08628 3.1384 5.0333 2.39551 4.96794 2.39551C4.90259 2.39551 4.84961 3.1384 4.84961 4.05481C4.84961 4.97122 4.90259 5.71412 4.96794 5.71412Z",
    fill: "url(#paint3_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96654 7.19961C5.09044 7.19961 5.19089 5.79211 5.19089 4.05586C5.19089 2.31961 5.09044 0.912109 4.96654 0.912109C4.84263 0.912109 4.74219 2.31961 4.74219 4.05586C4.74219 5.79211 4.84263 7.19961 4.96654 7.19961Z",
    fill: "url(#paint4_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96595 4.17417C4.04963 4.17417 3.30664 4.12116 3.30664 4.05583C3.30664 3.99051 4.04963 3.9375 4.96595 3.9375C5.88226 3.9375 6.62525 3.99029 6.62525 4.05583C6.62525 4.12138 5.88226 4.17417 4.96595 4.17417Z",
    fill: "url(#paint5_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96797 4.27975C3.23168 4.27975 1.82422 4.17924 1.82422 4.0554C1.82422 3.93157 3.23168 3.83105 4.96797 3.83105C6.70426 3.83105 8.11172 3.93157 8.11172 4.0554C8.11172 4.17924 6.70426 4.27975 4.96797 4.27975Z",
    fill: "url(#paint6_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02924 4.11618C4.56229 4.58314 4.15648 4.93462 4.12327 4.90141C4.09005 4.86819 4.44154 4.4626 4.90849 3.99543C5.37545 3.52848 5.78125 3.17677 5.81447 3.21021C5.84768 3.24342 5.49642 3.64901 5.02924 4.11618Z",
    fill: "url(#paint7_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08218 4.1701C4.1971 5.05496 3.42859 5.72119 3.36547 5.65784C3.30234 5.59472 3.96857 4.82599 4.85321 3.94113C5.73829 3.05627 6.5068 2.39004 6.56993 2.45339C6.63305 2.51651 5.96682 3.28502 5.08218 4.1701Z",
    fill: "url(#paint8_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90852 4.11618C4.44156 3.64901 4.08986 3.24342 4.12329 3.21021C4.15651 3.17677 4.56232 3.52848 5.02927 3.99543C5.49644 4.4626 5.84792 4.86819 5.81449 4.90141C5.78128 4.93462 5.37547 4.58314 4.90852 4.11618Z",
    fill: "url(#paint9_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85324 4.17007C3.96838 3.28499 3.30215 2.51649 3.3655 2.45336C3.42862 2.39023 4.19713 3.05624 5.08221 3.9411C5.96707 4.82596 6.6333 5.59469 6.56995 5.65782C6.50683 5.72094 5.73832 5.05493 4.85324 4.17007Z",
    fill: "url(#paint10_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75542 4.06132C6.75498 5.04889 5.95392 5.84885 4.96656 5.84841C3.97899 5.84775 3.17903 5.0467 3.17969 4.05934C3.18013 3.07176 3.98119 2.2718 4.96854 2.27246C5.95612 2.2729 6.75608 3.07396 6.75542 4.06132Z",
    fill: "url(#paint11_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9855 2.4248L4.96483 4.06497H4.95405L4.93359 2.4248H4.9855Z",
    fill: "url(#paint12_radial_2007_1268)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56187 2.47363L4.96636 4.06343L4.95602 4.06629L4.51172 2.48705L4.56187 2.47363Z",
    fill: "url(#paint13_radial_2007_1268)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16206 2.63184L4.96444 4.06261L4.9552 4.06811L4.11719 2.65779L4.16206 2.63184Z",
    fill: "url(#paint14_radial_2007_1268)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81994 2.8877L4.96522 4.06201L4.95752 4.06971L3.7832 2.92421L3.81994 2.8877Z",
    fill: "url(#paint15_radial_2007_1268)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55134 3.22266L4.96167 4.06067L4.95639 4.07012L3.52539 3.26775L3.55134 3.22266Z",
    fill: "url(#paint16_radial_2007_1268)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38256 3.61523L4.96158 4.05975L4.95872 4.07009L3.36914 3.66538L3.38256 3.61523Z",
    fill: "url(#paint17_radial_2007_1268)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32031 4.03906L4.9607 4.05974V4.07052L3.32031 4.09097V4.03906Z",
    fill: "url(#paint18_radial_2007_1268)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36914 4.46526L4.95872 4.06055L4.96158 4.07088L3.38256 4.51518L3.36914 4.46526Z",
    fill: "url(#paint19_radial_2007_1268)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52539 4.86293L4.95639 4.06055L4.96167 4.07L3.55134 4.9078L3.52539 4.86293Z",
    fill: "url(#paint20_radial_2007_1268)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7832 5.20681L4.95752 4.06152L4.96522 4.06922L3.81994 5.24354L3.7832 5.20681Z",
    fill: "url(#paint21_radial_2007_1268)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11719 5.47282L4.9552 4.0625L4.96444 4.068L4.16206 5.49878L4.11719 5.47282Z",
    fill: "url(#paint22_radial_2007_1268)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51172 5.64348L4.95602 4.06445L4.96636 4.06731L4.56187 5.65689L4.51172 5.64348Z",
    fill: "url(#paint23_radial_2007_1268)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93359 5.70582L4.95405 4.06543H4.96483L4.9855 5.70582H4.93359Z",
    fill: "url(#paint24_radial_2007_1268)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35979 5.65689L4.95508 4.06731L4.96542 4.06445L5.40994 5.64348L5.35979 5.65689Z",
    fill: "url(#paint25_radial_2007_1268)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75724 5.49878L4.95508 4.068L4.96432 4.0625L5.80233 5.47282L5.75724 5.49878Z",
    fill: "url(#paint26_radial_2007_1268)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10058 5.24354L4.95508 4.06922L4.96278 4.06152L6.13709 5.20681L6.10058 5.24354Z",
    fill: "url(#paint27_radial_2007_1268)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36714 4.9078L4.95703 4.07L4.96231 4.06055L6.39309 4.86293L6.36714 4.9078Z",
    fill: "url(#paint28_radial_2007_1268)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53628 4.51518L4.95703 4.07088L4.95989 4.06055L6.54969 4.46526L6.53628 4.51518Z",
    fill: "url(#paint29_radial_2007_1268)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59916 4.09097L4.95898 4.07052V4.05974L6.59916 4.03906V4.09097Z",
    fill: "url(#paint30_radial_2007_1268)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54969 3.66538L4.95989 4.07009L4.95703 4.05975L6.53628 3.61523L6.54969 3.66538Z",
    fill: "url(#paint31_radial_2007_1268)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39309 3.26775L4.96231 4.07012L4.95703 4.06067L6.36714 3.22266L6.39309 3.26775Z",
    fill: "url(#paint32_radial_2007_1268)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13709 2.92443L4.96278 4.06971L4.95508 4.06201L6.10058 2.8877L6.13709 2.92443Z",
    fill: "url(#paint33_radial_2007_1268)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80233 2.65779L4.96432 4.06811L4.95508 4.06261L5.75724 2.63184L5.80233 2.65779Z",
    fill: "url(#paint34_radial_2007_1268)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40994 2.48705L4.96542 4.06629L4.95508 4.06343L5.35979 2.47363L5.40994 2.48705Z",
    fill: "url(#paint35_radial_2007_1268)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M17.841 20.593C17.9063 20.593 17.9593 19.8501 17.9593 18.9337C17.9593 18.0173 17.9063 17.2744 17.841 17.2744C17.7756 17.2744 17.7227 18.0173 17.7227 18.9337C17.7227 19.8501 17.7756 20.593 17.841 20.593Z",
    fill: "url(#paint36_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8415 22.0766C17.9654 22.0766 18.0659 20.6691 18.0659 18.9328C18.0659 17.1966 17.9654 15.7891 17.8415 15.7891C17.7176 15.7891 17.6172 17.1966 17.6172 18.9328C17.6172 20.6691 17.7176 22.0766 17.8415 22.0766Z",
    fill: "url(#paint37_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8409 19.0521C16.9246 19.0521 16.1816 18.9991 16.1816 18.9338C16.1816 18.8684 16.9246 18.8154 17.8409 18.8154C18.7573 18.8154 19.5002 18.8682 19.5002 18.9338C19.5002 18.9993 18.7573 19.0521 17.8409 19.0521Z",
    fill: "url(#paint38_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8391 19.1587C16.1028 19.1587 14.6953 19.0581 14.6953 18.9343C14.6953 18.8105 16.1028 18.71 17.8391 18.71C19.5753 18.71 20.9828 18.8105 20.9828 18.9343C20.9828 19.0581 19.5753 19.1587 17.8391 19.1587Z",
    fill: "url(#paint39_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9003 18.9941C17.4334 19.4611 17.0276 19.8125 16.9944 19.7793C16.9611 19.7461 17.3126 19.3405 17.7796 18.8734C18.2465 18.4064 18.6523 18.0547 18.6856 18.0881C18.7188 18.1213 18.3675 18.5269 17.9003 18.9941Z",
    fill: "url(#paint40_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9552 19.0471C17.0701 19.9319 16.3016 20.5981 16.2385 20.5348C16.1754 20.4717 16.8416 19.7029 17.7263 18.8181C18.6113 17.9332 19.3799 17.267 19.443 17.3303C19.5061 17.3935 18.8399 18.162 17.9552 19.0471Z",
    fill: "url(#paint41_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7796 18.9941C17.3127 18.5269 16.961 18.1213 16.9944 18.0881C17.0276 18.0547 17.4334 18.4064 17.9004 18.8734C18.3675 19.3405 18.719 19.7461 18.6856 19.7793C18.6524 19.8125 18.2466 19.4611 17.7796 18.9941Z",
    fill: "url(#paint42_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7263 19.047C16.8414 18.1619 16.1752 17.3934 16.2385 17.3303C16.3017 17.2672 17.0702 17.9332 17.9553 18.8181C18.8401 19.7029 19.5063 20.4716 19.443 20.5348C19.3799 20.5979 18.6114 19.9319 17.7263 19.047Z",
    fill: "url(#paint43_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6265 18.9402C19.6261 19.9278 18.825 20.7278 17.8377 20.7273C16.8501 20.7267 16.0501 19.9256 16.0508 18.9382C16.0512 17.9507 16.8523 17.1507 17.8396 17.1514C18.8272 17.1518 19.6272 17.9529 19.6265 18.9402Z",
    fill: "url(#paint44_radial_2007_1268)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8566 17.3018L17.8359 18.9421H17.8251L17.8047 17.3018H17.8566Z",
    fill: "url(#paint45_radial_2007_1268)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M17.433 17.3516L17.8374 18.9411L17.8271 18.944L17.3828 17.365L17.433 17.3516Z",
    fill: "url(#paint46_radial_2007_1268)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0351 17.5098L17.8375 18.9408L17.8282 18.946L16.9902 17.5357L17.0351 17.5098Z",
    fill: "url(#paint47_radial_2007_1268)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6891 17.7646L17.8344 18.939L17.8269 18.9467L16.6523 17.8014L16.6891 17.7646Z",
    fill: "url(#paint48_radial_2007_1268)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4244 18.1006L17.8347 18.9386L17.8294 18.9478L16.3984 18.1455L16.4244 18.1006Z",
    fill: "url(#paint49_radial_2007_1268)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2536 18.4932L17.8327 18.9375L17.83 18.9478L16.2402 18.5433L16.2536 18.4932Z",
    fill: "url(#paint50_radial_2007_1268)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1914 18.918L17.8318 18.9384V18.9492L16.1914 18.9699V18.918Z",
    fill: "url(#paint51_radial_2007_1268)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2402 19.3422L17.83 18.9375L17.8327 18.9478L16.2536 19.3924L16.2402 19.3422Z",
    fill: "url(#paint52_radial_2007_1268)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3984 19.7397L17.8294 18.9375L17.8347 18.9467L16.4244 19.7847L16.3984 19.7397Z",
    fill: "url(#paint53_radial_2007_1268)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6523 20.084L17.8269 18.9385L17.8344 18.9462L16.6891 20.1205L16.6523 20.084Z",
    fill: "url(#paint54_radial_2007_1268)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9902 20.3505L17.8282 18.9404L17.8375 18.9457L17.0351 20.3765L16.9902 20.3505Z",
    fill: "url(#paint55_radial_2007_1268)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3828 20.5216L17.8271 18.9424L17.8374 18.9452L17.433 20.535L17.3828 20.5216Z",
    fill: "url(#paint56_radial_2007_1268)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8047 20.5835L17.8251 18.9434H17.8359L17.8566 20.5835H17.8047Z",
    fill: "url(#paint57_radial_2007_1268)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2309 20.535L17.8262 18.9452L17.8365 18.9424L18.281 20.5216L18.2309 20.535Z",
    fill: "url(#paint58_radial_2007_1268)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6303 20.3765L17.8281 18.9457L17.8374 18.9404L18.6754 20.3505L18.6303 20.3765Z",
    fill: "url(#paint59_radial_2007_1268)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9734 20.1205L17.8281 18.9462L17.8356 18.9385L19.0101 20.084L18.9734 20.1205Z",
    fill: "url(#paint60_radial_2007_1268)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2382 19.7847L17.8281 18.9467L17.8334 18.9375L19.2642 19.7397L19.2382 19.7847Z",
    fill: "url(#paint61_radial_2007_1268)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4091 19.3924L17.8301 18.9478L17.8327 18.9375L19.4225 19.3422L19.4091 19.3924Z",
    fill: "url(#paint62_radial_2007_1268)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4722 18.9699L17.832 18.9492V18.9384L19.4722 18.918V18.9699Z",
    fill: "url(#paint63_radial_2007_1268)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4225 18.5433L17.8327 18.9478L17.8301 18.9375L19.4091 18.4932L19.4225 18.5433Z",
    fill: "url(#paint64_radial_2007_1268)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2642 18.1455L17.8334 18.9478L17.8281 18.9386L19.2382 18.1006L19.2642 18.1455Z",
    fill: "url(#paint65_radial_2007_1268)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0101 17.8014L17.8356 18.9467L17.8281 18.939L18.9734 17.7646L19.0101 17.8014Z",
    fill: "url(#paint66_radial_2007_1268)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6754 17.5357L17.8374 18.946L17.8281 18.9408L18.6303 17.5098L18.6754 17.5357Z",
    fill: "url(#paint67_radial_2007_1268)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M18.281 17.365L17.8365 18.944L17.8262 18.9411L18.2309 17.3516L18.281 17.365Z",
    fill: "url(#paint68_radial_2007_1268)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2007_1268",
    x1: 11.5409,
    y1: 7.06336,
    x2: 14.8725,
    y2: 25.9822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E2D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2007_1268",
    x1: 5.86519,
    y1: 5.95412,
    x2: 19.218,
    y2: 19.3071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FDE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FDB813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FDE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FDB813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB813"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2007_1268",
    x1: 8.72496,
    y1: 5.98992,
    x2: 15.2597,
    y2: 18.2797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6AF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B56914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9F5210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#92430E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3F0E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.96791 4.05446) scale(0.118459 1.65919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.9665 4.05551) scale(0.224468 3.14398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.96581 4.05567) rotate(90) scale(0.118459 1.65919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.96783 4.05546) rotate(90) scale(0.224467 3.14398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.96478 4.05219) rotate(45) scale(0.0853538 1.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.96361 4.05222) rotate(45) scale(0.161784 2.26601)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.96961 4.05499) rotate(135) scale(0.0853538 1.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.96844 4.05499) rotate(135) scale(0.161784 2.26601)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.97096 4.03558) scale(1.78798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93887 4.05288) scale(1.97074 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.94062 4.05266) scale(1.97076 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93914 4.05316) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.9408 4.05365) scale(1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93835 4.05319) scale(1.97076 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93959 4.05272) scale(1.97076 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.94003 4.05292) scale(1.97075 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93959 4.05351) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93835 4.05307) scale(1.97076 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.9408 4.05317) scale(1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93914 4.05304) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.94062 4.05368) scale(1.97076 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93887 4.05333) scale(1.97074 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93968 4.05368) scale(1.97076 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93902 4.05304) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93836 4.05317) scale(1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.939 4.05307) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.9379 4.05351) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93831 4.05292) scale(1.97076 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.9379 4.05272) scale(1.97076 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.939 4.05319) scale(1.97076 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93836 4.05365) scale(1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93902 4.05316) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.93968 4.05266) scale(1.97076 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.841 18.9333) scale(0.118459 1.65919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8415 18.9326) scale(0.224466 3.14398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8409 18.9337) rotate(90) scale(0.118459 1.65918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8391 18.9342) rotate(90) scale(0.224467 3.14398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.0603541 0.0603542 -0.845345 0.845347 17.8339 18.928)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.114398 0.114398 -1.60231 1.60231 17.8347 18.9268)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.0603541 0.0603542 -0.845345 -0.845347 17.8412 18.9332)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.114398 0.114398 -1.60231 -1.60231 17.842 18.932)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8511 18.907) scale(1.78798 1.78798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.81 18.9301) scale(1.97085 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8117 18.9306) scale(1.97075 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8122 18.9313) scale(1.97074 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8099 18.9308) scale(1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8114 18.9311) scale(1.97076 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8107 18.9306) scale(1.97075 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8111 18.9318) scale(1.97075 1.97074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8107 18.9307) scale(1.97075 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8114 18.93) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8099 18.9303) scale(1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8122 18.931) scale(1.97074 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8117 18.9318) scale(1.97075 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.81 18.9313) scale(1.97085 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8108 18.9318) scale(1.97077 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8121 18.931) scale(1.97076 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8112 18.9303) scale(1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8101 18.93) scale(1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8107 18.9307) scale(1.97075 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8114 18.9318) scale(1.97076 1.97074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8107 18.9306) scale(1.97075 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8101 18.9311) scale(1.97076 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8112 18.9308) scale(1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8121 18.9313) scale(1.97076 1.97075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2007_1268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8108 18.9306) scale(1.97077 1.97076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.be22d033a18bb817cc13578a6a62eb87.svg";
export { ForwardRef as ReactComponent };